import React from 'react';
import { motion } from 'framer-motion';
const chapters = [{
  number: '01',
  title: 'El Engaño de los 50',
  objective: 'Comprender el impacto real de la caída estrogénica en el metabolismo.',
  highlights: ['Por qué tu cuerpo cambió de reglas sin avisarte', 'Los "ladrones de energía" ocultos en tu rutina', 'La mentira de la "fuerza de voluntad"']
}, {
  number: '02',
  title: 'El Interruptor Metabólico',
  objective: 'Aprender a combinar macronutrientes para estabilizar la insulina.',
  highlights: ['Los 3 alimentos "Silver" que reactivan la tiroides', 'La Regla de la Placa de Oro', 'Diferencia entre hambre física y hormonal']
}, {
  number: '03',
  title: 'Crono-Alimentación Silver',
  objective: 'Dominar la "Ventana de Oro": cuándo comer para maximizar la quema de grasa.',
  highlights: ['El horario que tus hormonas aman', 'Eliminar picos de insulina nocturnos', 'Sincronizar carbohidratos con tu ritmo circadiano']
}, {
  number: '04',
  title: 'Movimiento Sin Daño',
  objective: 'Realizar la rutina de 3 pasos para despertar el músculo dormido.',
  highlights: ['10 minutos de activación de flujo sanguíneo', 'El Micropulso de Tensión', 'Evitar la inflamación articular']
}, {
  number: '05',
  title: 'El Protocolo de 21 Días',
  objective: 'Consolidar los hábitos en un calendario ejecutable.',
  highlights: ['Tu hoja de ruta diaria completa', 'Preparación para las "crisis de la semana 2"', 'Calendario de desinflamación, adaptación y consolidación']
}];
export function ChapterPreview() {
  return <section className="py-16 md:py-24 bg-cream" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-12 text-center" data-id="element-25">
          Dentro de tu guía
        </motion.h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-26">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-shadow" data-id="element-27">
              <div className="font-serif text-6xl text-sage-primary/30 mb-4" data-id="element-28">
                {chapter.number}
              </div>
              <h3 className="font-serif text-xl text-forest mb-2" data-id="element-29">
                {chapter.title}
              </h3>
              <p className="text-sm text-terracotta font-medium mb-4" data-id="element-30">
                {chapter.objective}
              </p>
              <ul className="space-y-2" data-id="element-31">
                {chapter.highlights.map((highlight, i) => <li key={i} className="text-sm text-forest/70 flex items-start gap-2" data-id="element-32">
                    <span className="text-sage-dark mt-1" data-id="element-33">•</span>
                    <span data-id="element-34">{highlight}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}